import React from 'react';
import MediaQuery from 'react-responsive';

import './Landing.css';
import LandingImage from '../../images/about/about-cover.png';

function LandingSection() {
  return (
    <div id="aboutLanding">
      <img src={LandingImage} alt="Voxar researchers working on computers" />
      <div id="aboutHeader">
        <h1>
          De onde vem
          <br />
          tanta inovação
        </h1>
        <p>
          Somos um laboratório de P&D
          <MediaQuery query="(min-width: 425px)">
            <br />
          </MediaQuery>
          {' '}
          com a missão de formar pessoas
          <MediaQuery query="(min-width: 425px)">
            <br />
          </MediaQuery>
          {' '}
          expandindo realidades e experiências.
        </p>
      </div>
    </div>
  );
}

export default LandingSection;
